import InstallationPlatforms from "../../../../contents/docs/error-tracking/installation/_snippets/installation-platforms";
import * as React from 'react';
export default {
  InstallationPlatforms,
  React
};